/**
 * Neo 桥名称清单
 */
// tslint:disable:trailing-comma
export enum BridgeName {
  // 参数隧道桥
  ParamTunnel = 'neohybrid.useParamTunnel',
  // 获取主接口数据桥
  HybridFetch = 'neohybrid.hybridFetch',
  // JS 主动通知 NEO Native
  JSNotifyNative = 'neohybrid.notifyRender',
  // 截屏桥
  ScreenCapture = 'neohybrid.useScreenCapture',
  // 长连接 Shark 能力桥
  SharkRequest = 'pay.sharkRequest',
}

/**
 * 参数隧道桥 Action
 */
export enum ParamTunnelBridgeAction {
  AllParams = 'getAllParams',
  // TODO 后续 Native 会删除以下 Action
  // AllBussinessParams = 'getAllBussinessParams',
  // AllGlobalParams = 'getAllGlobalParams',
  // SpecifiedParams = 'getSpecifiedParams',
}

export enum JSNotifyNativeBridgeAction {
  // H5 通知Native的事件，表示JS执行完成
  PageReadyToNative = 'notify_js_loaded',
  // 预渲染完成(App启动阶段)
  AppStartPreRenderFinished = 'notify_pre_render_finished',
  // 数据到达后页面渲染完成
  DataReadyRenderFinished = 'notify_render_finished',
  // 降级
  NotifyDowngrade = 'notify_downgrade',
}

/**
 * Shark 桥参数
 */
export interface SharkFetchParams {
  host?: string;
  path: string;
  params: {
    [key: string]: string;
  };
}

/**
 * 桥相关错误类型
 */
export enum BridgeErrorType {
  Timeout = 'neo_bridge_timeout',
  Fail = 'neo_bridge_fail',
}

/**
 * 桥执行返回的数据结构
 * 对齐后的标准结构
 */
export interface ExecuteBridgeResult<T> {
  errorCode: number;
  errorMsg: string;
  status: string;
  result: string;
  response: {
    status: string;
    data: T;
    error: {
      error_code: string;
      error_message: string;
    };
  };
}

export interface ExecuteSharkBridgeResult<T> extends ExecuteBridgeResult<T> {}
